import { useRef, useState } from "react";
import MaterialIcon from "./MaterialIcon";
import { Period } from "../types";

interface EndPeriodFormProps {
  handleSubmit: (endDate: string, newPeriodName: string) => void;
  currentPeriod: Period;
}

export default function EndPeriodForm({
  handleSubmit,
  currentPeriod,
}: EndPeriodFormProps) {
  let [endDate, setEndDate] = useState<string>("");
  let [periodName, setPeriodName] = useState<string>("");
  let dateInput = useRef<HTMLInputElement>(null);

  function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    let end_date = new Date(endDate);
    let start_date = new Date(currentPeriod.start_date);

    if (end_date < start_date) {
      dateInput.current?.setCustomValidity(
        "End date cannot be before the period start date!",
      );
      dateInput.current?.reportValidity();
      return;
    }

    handleSubmit(endDate, periodName);
    setEndDate("");
    setPeriodName("");
  }

  return (
    <>
      <section className="bg-grayscale-900 shadow-grayscale-900 m-auto rounded-lg p-3 shadow">
        <h2 className="px-4 text-center font-semibold">End Period</h2>
        <p>Close current period and start a new one.</p>
        <form className="flex flex-col" onSubmit={submit}>
          <label className="mb-1 mt-2">End Date:</label>
          <input
            type="date"
            required
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              dateInput.current?.setCustomValidity("");
            }}
            className="text-grayscale-900 rounded-lg border-2 p-2 focus:invalid:border-red-500"
            placeholder="e.g. April"
            ref={dateInput}
          />
          <label className="mb-1 mt-2">New Period Name:</label>
          <input
            type="text"
            required
            value={periodName}
            onChange={(e) => setPeriodName(e.target.value)}
            className="text-grayscale-900 rounded-lg border-2 p-2 focus:invalid:border-red-500"
            placeholder="e.g. May"
          />
          <button
            className="from-blu-200 to-blu-600 mt-4 flex items-baseline justify-center rounded-lg bg-gradient-to-tr p-2"
            type="submit"
          >
            <MaterialIcon icon="add" />
          </button>
        </form>
      </section>
    </>
  );
}
